import { combineReducers } from 'redux';
import { entityReducer } from './entity-reducer';
import { componentReducer } from './component-reducer';
import { userReducer } from './user-reducer';
export var reducers = combineReducers({
  // 存放实体
  entities: entityReducer,
  // 存放组件状态
  components: componentReducer,
  // 存放用户信息
  user: userReducer
});